import { IBuilderState, FlowSimulatorState } from 'common/builder/builderInterfaces'
import { NodeType } from 'common/builder/constants/NodeType'
import * as builderStateSelectors from 'common/builder/selectors/builder/builderStateSelectors'
import { getBuilderById } from 'common/builder/selectors/builder/commonSelectors'

export const getFlowSimulatorState = (state: RootState, builderId: string): FlowSimulatorState => {
  const builderState: IBuilderState = builderStateSelectors.getById(state, builderId)
  return builderState?.flowSimulator
}

export const isFlowSimulatorOpen = (state: RootState, builderId: string) => {
  return getFlowSimulatorState(state, builderId)?.open
}

export const getSimulatorData = (state: RootState, builderId: string) => {
  const builder = getBuilderById(state, builderId)

  const nodes = { byId: { ...builder.nodes.byId } }
  Object.keys(builder.nodes.byId).forEach((nodeId) => {
    const node = builder.nodes.byId[nodeId]
    if (
      node.deleted ||
      node.nodeType === NodeType.COMMENT ||
      node.nodeType === NodeType.STARTING_STEP
    ) {
      delete nodes.byId[nodeId]
    }
  })

  const rootId = builder.state.rootId

  return {
    nodes,
    blocks: builder.blocks,
    buttons: builder.buttons,
    state: { rootId: rootId ? String(rootId) : null },
  }
}
